import { useState, useEffect } from 'react';

const STORAGE_KEY = 'podus-cookie-consent';

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(STORAGE_KEY);
        if (!consent) setVisible(true);
    }, []);

    if (!visible) return null;

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        setVisible(false);
    };

    const dismiss = () => {
        localStorage.setItem(STORAGE_KEY, 'dismissed');
        setVisible(false);
    };

    return (
        <>
            {/* ── Desktop banner ── */}
            <div className="fixed inset-x-0 bottom-0 z-50 hidden lg:block">
                <div className="mx-auto max-full px-6 pb-5">
                    <div className="flex items-center gap-6 rounded-2xl border border-[#e8e8e8] bg-white px-8 py-4 shadow-[0_-4px_24px_rgba(0,0,0,0.06)]">
                        <p className="flex-1 text-sm leading-relaxed text-[#555]">
                            Our website use cookies. By continuing navigating, we assume your permission to deploy
                            cookies as detailed in our Privacy Policy.
                        </p>

                        <div className="flex shrink-0 items-center gap-3">
                            <button
                                type="button"
                                onClick={accept}
                                className="flex cursor-pointer items-center gap-2 rounded-full bg-[#151515] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#333]"
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-.17.01-.34.02-.51a5.5 5.5 0 0 0 3.48.51 3.5 3.5 0 0 0 5-3.5 5.5 5.5 0 0 0 6.5-1.5c.63 1.21 1 2.58 1 4 0 4.42-3.58 8-8 8z" />
                                </svg>
                                Accept Cookies
                            </button>
                            <button
                                type="button"
                                onClick={accept}
                                className="cursor-pointer rounded-full bg-[#151515] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#333]"
                            >
                                Cookies Preference
                            </button>
                        </div>

                        <button
                            type="button"
                            onClick={dismiss}
                            className="flex shrink-0 cursor-pointer items-center justify-center text-[#999] transition-colors hover:text-[#555]"
                            aria-label="Close"
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            {/* ── Mobile card ── */}
            <div className="fixed inset-x-0 bottom-0 z-50 p-4 lg:hidden">
                <div className="rounded-2xl border border-[#e8e8e8] bg-white p-5 shadow-[0_-4px_24px_rgba(0,0,0,0.08)]">
                    <div className="mb-3 flex items-center justify-between">
                        <h3 className="text-base font-bold text-[#151515]">Accept Cookies</h3>
                        <button
                            type="button"
                            onClick={dismiss}
                            className="flex cursor-pointer items-center justify-center text-[#999] transition-colors hover:text-[#555]"
                            aria-label="Close"
                        >
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </div>

                    <p className="mb-4 text-xs sm:text-sm leading-relaxed text-[#555]">
                        Our website use cookies. By continuing navigating, we assume your permission to deploy cookies
                        as detailed in our Privacy Policy.
                    </p>

                    <div className="flex items-center gap-2 sm:gap-3">
                        <button
                            type="button"
                            onClick={accept}
                            className="flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-[#151515] px-3 py-2 text-xs sm:px-5 sm:py-2.5 sm:text-sm font-medium text-white transition-colors hover:bg-[#333]"
                        >
                            <svg className="shrink-0" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-.17.01-.34.02-.51a5.5 5.5 0 0 0 3.48.51 3.5 3.5 0 0 0 5-3.5 5.5 5.5 0 0 0 6.5-1.5c.63 1.21 1 2.58 1 4 0 4.42-3.58 8-8 8z" />
                            </svg>
                            Accept Cookies
                        </button>
                        <button
                            type="button"
                            onClick={accept}
                            className="shrink-0 cursor-pointer whitespace-nowrap rounded-full bg-[#151515] px-3 py-2 text-xs sm:px-5 sm:py-2.5 sm:text-sm font-medium text-white transition-colors hover:bg-[#333]"
                        >
                            Cookies Preference
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
